module.exports = __webpack_public_path__ + "static/nube-color-d51085806c77de7a004bd35e2f7d86b0.png";